import { render, staticRenderFns } from "./SundryOrderConfirmation.vue?vue&type=template&id=3e64e540&"
import script from "./SundryOrderConfirmation.vue?vue&type=script&lang=js&"
export * from "./SundryOrderConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./SundryOrderConfirmation.vue?vue&type=style&index=0&id=3e64e540&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports